import {combineReducers, createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiHost} from "../apiData";
import {getLanguage} from "../locales/langUtils";
import {parseOrReject} from "../utils/utils";

export const executeReactivateFetch = createAsyncThunk(
    'reactivateFetch/executeReactivateFetch',
    async (_, {getState, rejectWithValue}) => {
        try {
            const state = getState().reactivate.reactivateForm;
            const response = await fetch(`${apiHost}/api/user/resend-activation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': getLanguage()
                },
                body: JSON.stringify({
                    username: state.username
                }),
                credentials: 'include'
            });

            return await parseOrReject(response, rejectWithValue);
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const reactivateFetchSlice = createSlice(
    {
        name: 'reactivateFetch',
        initialState: {
            isLoading: false,
            errorData: null
        },
        extraReducers: (builder) => {
            builder.addCase(executeReactivateFetch.pending, state => {
                state.isLoading = true;
            }).addCase(executeReactivateFetch.fulfilled, (state, action) => {
                state.isLoading = false;
                window.location.href = action.payload.redirectUrl;
            }).addCase(executeReactivateFetch.rejected, (state, action) => {
                state.isLoading = false;
                state.errorData = action.payload;
            })
        }
    }
)

export const reactivateFormSlice = createSlice(
    {
        name: 'reactivateForm',
        initialState: {
            username: '',
        },
        reducers: {
            setUsername: (state, action) => {
                state.username = action.payload
            }
        }
    });

export const {setUsername} = reactivateFormSlice.actions;

const reactivateReducer = combineReducers({
    reactivateForm: reactivateFormSlice.reducer,
    reactivateFetch: reactivateFetchSlice.reducer,
});

export default reactivateReducer;